<app-dialog-header [title]="articleData?.posting ? 'ENGAGE.POSTING.HEADER_EDIT' : 'ENGAGE.POSTING.HEADER'" (onClick)="dialogRef.close(null)"></app-dialog-header>

<div fxLayout="column" fxLayoutAlign="start" class="p-24 pb-0 new-posting-container" *ngIf="formGroup">
    <form name="new-posting" [formGroup]="formGroup">
        <div fxLayout="column" fxLayout.gt-xs="row" fxLayoutGap="0" fxLayoutGap.gt-xs="6%">
            <mat-form-field formGroupName="postingType" fxFlex="1 0 100%" fxFlex.gt-xs="1 0 47%">
                <mat-label>{{ 'GENERAL.PROPERTY.TYPE' | translate }}</mat-label>
                <mat-select formControlName="type">
                    <mat-option [value]="postingType.id" *ngFor="let postingType of formTypes">{{ postingType.displayNameKeySingular | translate }}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field fxFlex.gt-xs="1 0 47%" formGroupName="translations" class="readonly">
                <mat-label>{{ 'GENERAL.PROPERTY.LANGUAGE' | translate }}</mat-label>
                <mat-select formControlName="language">
                    <mat-option *ngFor="let lang of languageService.languages | filterLanguages" [value]="lang.id">
                        <span fxLayout="row" fxLayoutAlign="start center">
                            <img alt="" class="flag mr-16" [src]="'assets/images/flags/' + lang.flag + '.svg'" />
                            <span class="iso" [translate]="lang.translate">{{ lang.title }}</span>
                        </span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="posting-image-wrapper mb-24">
            <div *ngIf="!maxBrainImageSelected || !maxBrainImageSelected.url" class="posting-image-container" fxLayout="row" fxLayoutAlign="flex-start center">
                <div class="preview-container pointer" fxLayout="row" fxLayoutAlign="center center" (click)="openImageLibraryDialog()">
                    <div class="preview-bg-container">
                        <div class="img-icon"></div>
                        <div class="preview-title">
                            {{ 'IMAGE_LIBRARY.DIALOG.LABELS.IMAGE_PREVIEW' | translate }}
                        </div>
                    </div>
                </div>
                <div fxLayout="column" class="ml-24">
                    <app-white-button class="mr-8 mb-28" [label]="'IMAGE_LIBRARY.BUTTONS.SELECT_IMAGE'" (onClick)="openImageLibraryDialog()"></app-white-button>
                    <p class="about-image-upload">
                        {{ 'ENGAGE.HOME_EXPERIENCE_BANNER.LABELS.IMAGE_RECCOMENDED_DIMENSTION' | translate }}
                        <br />
                        {{ 'ENGAGE.HOME_EXPERIENCE_BANNER.LABELS.IMAGE_SUPPORTED_FORMATS' | translate }} <br />
                        {{ 'ENGAGE.HOME_EXPERIENCE_BANNER.LABELS.IMAGE_MAX_FILE_SIZE' | translate }}
                    </p>
                    <mat-error *ngIf="formGroup.dirty && controls.img.hasError('required')">
                        {{ 'ERROR.RESPONSE.' + 'required' | translate }}
                    </mat-error>
                </div>
            </div>
            <div *ngIf="maxBrainImageSelected && maxBrainImageSelected.url" class="posting-image-container" fxLayout="row" fxLayoutAlign="flex-start center">
                <div class="posting-image-bg pointer" (click)="openImageLibraryDialog()" [style.background-image]="'url(' + maxBrainImageSelected.url + ')'"></div>
                <img style="display: none" *ngIf="maxBrainImageSelected.unsplash" [src]="unsplashViewsBaseUrl + maxBrainImageSelected.unsplash.unsplashId" />
                <div fxLayout="column" class="ml-48" *ngIf="postingType.name !== 'article'">
                    <app-white-button class="mr-8 mb-28" [label]="'IMAGE_LIBRARY.BUTTONS.CHANGE_IMAGE'" (onClick)="openImageLibraryDialog()"></app-white-button>
                </div>
            </div>
        </div>

        <div formGroupName="translations">
            <mat-form-field class="w-100-p readonly">
                <input matInput name="title" formControlName="title" maxlength="256" [placeholder]="'ENGAGE.POSTING.LABELS.TITLE' | translate" />
                <mat-error *ngIf="controls.title.touched && controls.title.hasError('required')">
                    {{ 'ERROR.RESPONSE.' + 'required' | translate }}
                </mat-error>
            </mat-form-field>

            <mat-form-field class="w-100-p readonly">
                <mat-label>{{ 'ENGAGE.POSTING.SHORT_DESCRIPTION' | translate }}</mat-label>
                <p class="posting-description" [innerHTML]="formGroup.get('translations.description').value | safeHtml"></p>
                <!-- Allows us to use mat-form-field styles-->
                <input matInput name="description" formControlName="description" style="display: none" />
                <mat-error *ngIf="controls.description.touched && controls.description.hasError('required')">
                    {{ 'ERROR.RESPONSE.' + 'required' | translate }}
                </mat-error>
            </mat-form-field>
        </div>

        <mat-form-field class="w-100-p">
            <label class="url-label">{{ 'ENGAGE.POSTING.URL' | translate }}</label>
            <mat-icon class="info-icon" matTooltip="{{ 'ENGAGE.POSTING.CONTENT_TOOLTIP' | translate }}">info</mat-icon>
            <input type="url" matInput name="url" formControlName="url" />
            <mat-error *ngIf="controls.description.touched && controls.url.hasError('required')">
                {{ 'ERROR.RESPONSE.' + 'required' | translate }}
            </mat-error>
            <mat-error *ngIf="controls.description.touched && controls.url.hasError('pattern')">
                {{ 'ERROR.RESPONSE.' + 'invalid_url' | translate }}
            </mat-error>
        </mat-form-field>

        <div fxLayout="column" fxLayout.gt-xs="row" fxLayoutGap="0" fxLayoutGap.gt-xs="6%">
            <mat-form-field fxFlex="1 0 100%" fxFlex.gt-xs="1 0 47%">
                <input
                    matInput
                    [matDatepicker]="pickerValidFrom"
                    formControlName="validFrom"
                    (focus)="pickerValidFrom.open()"
                    [placeholder]="'GENERAL.PROPERTY.VALID_FROM' | translate"
                    (ngModelChange)="updateEndDate()"
                />
                <mat-datepicker-toggle matSuffix [for]="pickerValidFrom"></mat-datepicker-toggle>
                <mat-datepicker #pickerValidFrom></mat-datepicker>
            </mat-form-field>

            <mat-form-field fxFlex="1 0 100%" fxFlex.gt-xs="1 0 47%">
                <input
                    matInput
                    formControlName="validTo"
                    [min]="formGroup.controls.validFrom.value"
                    [matDatepicker]="pickerValidTo"
                    (focus)="pickerValidTo.open()"
                    [placeholder]="'GENERAL.PROPERTY.VALID_TO' | translate"
                />
                <mat-datepicker-toggle matSuffix [for]="pickerValidTo"></mat-datepicker-toggle>
                <mat-datepicker #pickerValidTo></mat-datepicker>
            </mat-form-field>
        </div>
    </form>
</div>

<div class="pt-24 action-buttons">
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>

    <app-flat-button [label]="'GENERAL.BUTTON.SAVE'" (onClick)="createPosting()" [disabled]="formGroup.invalid"></app-flat-button>
</div>
